import React from 'react';
import { MessageSquare, Clock, FileCheck } from 'lucide-react';

const WORAUF_ANKOMMT = [
  {
    icon: MessageSquare,
    title: 'Kommunikation & Erreichbarkeit',
    text: 'Schnelle Rückmeldung und klare Absprachen sind die Basis für einen reibungslosen Ablauf.'
  },
  {
    icon: Clock,
    title: 'Strukturierter Ablauf',
    text: 'Termin vereinbaren, vor Ort begutachten, Gutachten erstellen – ohne unnötige Verzögerungen.'
  },
  {
    icon: FileCheck,
    title: 'Nachvollziehbare Dokumentation',
    text: 'Eine klare, sachliche Schadenfeststellung hilft bei der Regulierung und vermeidet Missverständnisse.'
  }
];

export const WarumBewertungenWichtig = () => {
  return (
    <section className="py-28 lg:py-36 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-brand-green/8 text-brand-green-dark rounded-full text-sm font-semibold mb-6 border border-brand-green/15">
            Vertrauen
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 tracking-tight">
            Worauf es bei einem Gutachter ankommt
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-12">
          {WORAUF_ANKOMMT.map((punkt, index) => {
            const Icon = punkt.icon;
            return (
              <div key={index} className="bg-white border border-gray-200 rounded-3xl p-8 hover:border-brand-green/30 hover:shadow-xl transition-all duration-300">
                <div className="w-16 h-16 bg-brand-green/10 rounded-2xl flex items-center justify-center mx-auto mb-6 border border-brand-green/15">
                  <Icon className="w-8 h-8 text-brand-green" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3 text-center tracking-tight">{punkt.title}</h3>
                <p className="text-gray-600 leading-relaxed text-[15px] text-center">{punkt.text}</p>
              </div>
            );
          })}
        </div>

        <div className="text-center max-w-2xl mx-auto">
          <p className="text-gray-700 leading-relaxed text-lg">
            Wir arbeiten sachlich, unabhängig und transparent – ohne unnötige Versprechen.
          </p>
        </div>
      </div>
    </section>
  );
};